@if (isLoggedIn) {
  <app-sidebar />
  <main class="app-shell app-shell--with-sidebar">
    <router-outlet />
  </main>
} @else {
  <main class="app-shell">
    <router-outlet />
  </main>
}
